export default __webpack_public_path__ + "static/media/image28.9e93c356.png";